/* eslint-disable spire/export-styles */
import AddToListModal from "@insite/content-library/Components/AddToListModal";
import ManageShareListModal from "@insite/content-library/Components/ManageShareListModal";
import ProductDeliveryScheduleModal from "@insite/content-library/Components/ProductDeliveryScheduleModal";
import ProductSelectorVariantModal from "@insite/content-library/Components/ProductSelectorVariantModal";
import ShareListDetailModal from "@insite/content-library/Components/ShareListDetailModal";
import ShareListModal from "@insite/content-library/Components/ShareListModal";
import * as React from "react";

/* Poolcorp Custom Code */
import AddressBookModal from "@store/Components/Store/AddressBookModal";
/* Poolcorp Custom Code */

interface OwnProps {
    skipInventoryValidation?: boolean;
    skipProductPrice?: boolean;
}

type Props = OwnProps;

const Modals = ({ skipInventoryValidation, skipProductPrice }: Props) => (
    <>
        <AddToListModal />
        <ShareListModal />
        <ManageShareListModal />
        <ShareListDetailModal />
        <ProductSelectorVariantModal
            skipInventoryValidation={skipInventoryValidation}
            skipProductPrice={skipProductPrice}
        />
        <ProductDeliveryScheduleModal />
        <AddressBookModal /> {/* Poolcorp Custom Code */}
    </>
);

export default Modals;
